module.exports = flarum.core.compat['Model'];